import React, { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";

import { useApi } from "../../../hooks/useApi";
import HelperSelect from "./HelperSelect";

const JobRequestChangeHelperForm = ({ job, onSuccess, onCancel }) => {
  const [helper, setHelper] = useState(null);
  const { call, isLoading } = useApi({
    onError: (err) => toast.error(err.message),
  });

  const onSubmit = (e) => {
    e.preventDefault();

    if (!helper?.value) {
      toast.error("Please select a helper.");
      return;
    }

    call(
      `/admin/job-requests/${job._id}/change-requested-helper`,
      "put",
      undefined,
      { helperId: helper.value },
      () => {
        onSuccess();
      }
    );
  };

  return (
    <Form onSubmit={onSubmit} className="mb-3">
      <p className="text-muted small">
        Replaces who this open job is offered to. It stays unconfirmed until
        the new helper accepts. A helper who was not already requested gets the
        same new-request message as a new booking.
      </p>
      <Form.Group className="mb-3">
        <Form.Label>New Helper</Form.Label>
        <HelperSelect
          value={helper}
          onChange={(val) => setHelper(val)}
          showDefaultOptions={true}
        />
      </Form.Group>
      <div className="d-flex justify-content-start align-items-center gap-2">
        <Button type="submit" variant="primary" disabled={isLoading || !helper}>
          Change Helper
        </Button>
        <Button variant="link" onClick={() => onCancel()} disabled={isLoading}>
          Cancel
        </Button>
      </div>
    </Form>
  );
};

export default JobRequestChangeHelperForm;
